module.exports = __webpack_public_path__ + "static/img/d.b3e1d6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/d.png
// module id = nRqL
// module chunks = 0